// extracted by mini-css-extract-plugin
export default {"eventsHeading":"Events_eventsHeading__zYBIA","eventsIntro":"Events_eventsIntro__7V7c3"};